import styled from 'styled-components';
import { darkGrey1 } from '../../common/colors';

export const StyledBlankLayout = styled.div<{ bgColor?: string }>`
  background-color: ${({ bgColor }) => bgColor || darkGrey1};
`;
